import { render, staticRenderFns } from "./ShowDragDrop.vue?vue&type=template&id=6b717644&scoped=true"
import script from "./ShowDragDrop.vue?vue&type=script&lang=js"
export * from "./ShowDragDrop.vue?vue&type=script&lang=js"
import style0 from "./ShowDragDrop.vue?vue&type=style&index=0&id=6b717644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b717644",
  null
  
)

export default component.exports